import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/tables/data/authorsTableData";
import axios from "axios";
import { useState } from "react";
import { json } from "react-router-dom";
import { useEffect, useCallback } from 'react';
import DefaultNavbarMobile from "examples/Navbars/DefaultNavbar/DefaultNavbarMobile";
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Loading from "components/Loading";
import appBar from "assets/theme/components/appBar";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import { blue } from "@mui/material/colors";
import apiClient from "Api"
import { useSnackbar } from 'notistack';

function Stores() {

    const [columns, setColumns] = useState([
        { Header: "Shopify Domain", accessor: "shopifyDomain", width: "30%", align: "left" },
        { Header: "Apps Instalados", accessor: "apps", align: "left" },
        { Header: "Data criação", accessor: "createDate", align: "left" }
    ]);

    const [rows, setRows] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [isLoading, setIsLoading] = useState(false);
    const [timeRange, setTimeRange] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const { enqueueSnackbar } = useSnackbar();

    const [tableData, setTableData] = useState({ columns: columns, rows: rows, pageCount: pageCount, pageIndex: pageIndex, pageSize: 10, pageChangeHandle: handlePageChange, search: "", timeRange: timeRange });

    function handlePageChange(pageIndexNew, pageSizeNew, search, timeNew) {
        debugger;
        const fetchData = async () => {
            let newPageIndex = pageIndexNew != null ? pageIndexNew : pageIndex;
            let newPageSize = pageSizeNew != null ? pageSizeNew : pageSize;
            let newTimeRange = timeNew != null ? timeNew : timeRange;

            search = search ? search : "";

            setIsLoading(true);

            let dateRange = "";

            if (newTimeRange != null) {
              dateRange = `&DateFilter=${newTimeRange}`;
            }

            apiClient.get(`/admin/tenants?PageIndex=${newPageIndex}&PageSize=${newPageSize}&ShopifyDomain=${search}&AppType=${search}${dateRange}`).then(reponseSales => {
                setPageIndex(newPageIndex);
                setPageSize(newPageSize);
                setTimeRange(newTimeRange);

                let rowsPage = [];
                reponseSales.data.value.map((item) => {
                    let urlStore = `/stores/${item.id}`;

                    rowsPage.push({
                        shopifyDomain: (
                            <MDTypography component="a" href={urlStore} variant="button" color="text" fontWeight="medium" key={item.id} >
                                {item.shopifyDomain}                                
                            </MDTypography>),
                        apps: (
                            <MDTypography component="a" href={urlStore} variant="button" color="text" fontWeight="medium">
                                {item.apps.some((x) => x.type == "Boleto") && <Chip label="Boleto" variant="outlined" color={item.apps.some((x) => x.type == "Boleto" && x.status !== "UNINSTALLED") ? "success" : "error"} sx={{ mr: 1 }} />}
                                {item.apps.some((x) => x.type == "Pix") && <Chip label="Pix" variant="outlined" color={item.apps.some((x) => x.type == "Pix" && x.status !== "UNINSTALLED") ? "success" : "error"} sx={{ mr: 1 }} />}
                                {item.apps.some((x) => x.type == "CreditCard") && <Chip label="Cartão de crédito" color={item.apps.some((x) => x.type == "CreditCard" && x.status !== "UNINSTALLED") ? "success" : "error"} variant="outlined" sx={{ mr: 1 }} />}
                                {item.apps.some((x) => x.type == "FraudAnalysis") && <Chip label="Análise de risco" color={item.apps.some((x) => x.type == "FraudAnalysis" && x.status !== "UNINSTALLED") ? "success" : "error"} variant="outlined" sx={{ mr: 1 }} />}
                                {item.apps.some((x) => x.type == "CustomCreditCard") && <Chip label="Cartão de crédito(Custom)" color={item.apps.some((x) => x.type == "CustomCreditCard" && x.status !== "UNINSTALLED") ? "success" : "error"} variant="outlined" sx={{ mr: 1 }} />}
                                {item.apps.some((x) => x.type == "ProtectedCard") && <Chip label="Cartão Protegido" color={item.apps.some((x) => x.type == "ProtectedCard" && x.status !== "UNINSTALLED") ? "success" : "error"} variant="outlined" sx={{ mr: 1 }} />}
                            </MDTypography>),
                        createDate: (
                            <MDTypography component="a" href="#" variant="button" color="text" fontWeight="medium">
                                {new Date(item.createdAtUtc).toLocaleString()}                          
                            </MDTypography>)
                    })
                });

                setRows(rowsPage);

                setTableData({ columns: columns, rows: rowsPage, pageCount: reponseSales.data.totalItems, pageIndex: newPageIndex, pageSize: newPageSize, pageChangeHandle: handlePageChange, search: search, timeRange: newTimeRange });
                setIsLoading(false);
            }).catch(e => {
                setIsLoading(false);
                enqueueSnackbar(`Erro ao retornar as lojas!)`, { variant: "error" });
            });
        };

        fetchData();
    }

    useEffect(() => {
        handlePageChange(pageIndex, pageSize, "", timeRange);
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={3} pb={4}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={1.5}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Lojas
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={2}>
                                <Loading isLoading={isLoading}></Loading>
                                <DataTable
                                    table={tableData}
                                    isSorted={true}
                                    entriesPerPage={true}
                                    showTotalEntries={true}
                                    canSearch={true}
                                    noEndBorder
                                    searchPlaceHolder="Shopify domain ou tipo do app"
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default Stores;